import { debounce } from 'lodash';

export default {
  data() {
    return {
      search: '',
    };
  },
  methods: {
    setSearchDebounce(search) {
      this.$startLoading('search');
      this._setSearchDebounce(search);
    },
    _setSearchDebounce: debounce(function setSearchDebounce(search) {
      this.setSearch(search);
      this.$stopLoading('search');
    }, 200),
    setSearch(search) {
      this.search = search;
    },
    getSearch() {
      return this.search;
    },
  },
};
